import { get } from "lodash";

export const assignments = (state, formId) =>
  get(state, ["formsV2", "assignments", formId], {
    accounts: [],
    contacts: [],
    types: [],
    contactTypes: []
  });
